import { takeLatest, put, take } from 'redux-saga/effects';

import {
  actions as getPatientInsurancesListActions,
  consts as getPatientInsurancesListConsts,
} from '../requests/get-patient-insurances-list';

import {
  MANAGE_INSURANCES_ACTION_TYPES,
  manageInsurancesActions,
} from '../actions/manage-insurances-actions';

function* downloadToDoTaskInsurancesDataWorker({ payload }) {
  yield put(manageInsurancesActions.setInsuranceRelatedDataFetching(true));

  const { userId, todoTaskAssignmentId } = payload;

  yield put(
    getPatientInsurancesListActions.send({ userId, todoTaskAssignmentId }),
  );

  yield take(getPatientInsurancesListConsts.SUCCEED);

  yield put(manageInsurancesActions.setInsuranceRelatedDataFetching(false));
}

export function* downloadToDoTaskInsurancesData() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_TO_DO_TASK_INSURANCES_DATA,
    downloadToDoTaskInsurancesDataWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/download-to-do-task-insurances-data.js